module.exports = __webpack_public_path__ + "static/media/JD.1a66112f.svg";